import { Button } from "@mui/material";
import React from "react";

export default function ActionButton({
  color = "default",
  children,
  onClick,
  label,
}) {
  const colorStyles = {
    default: {
      backgroundColor: "#f8f9fa",
      color: "#444",
      border: "1px solid #ddd",
      "&:hover": {
        backgroundColor: "#fff",
        borderColor: "#FF6A00",
        color: "#FF6A00",
      },
    },
    error: {
      backgroundColor: "#ffebee",
      color: "#d32f2f",
      border: "1px solid #f8bbd0",
      "&:hover": {
        backgroundColor: "#ffcdd2",
      },
    },
    success: {
      backgroundColor: "#e8f5e9",
      color: "#2e7d32",
      border: "1px solid #c8e6c9",
      "&:hover": {
        backgroundColor: "#c8e6c9",
      },
    },
    call: {
      backgroundColor: "#e0f7f9",
      color: "#007c91",
      border: "1px solid #b2ebf2",
      "&:hover": {
        backgroundColor: "#b2ebf2",
        borderColor: "#007c91",
      },
    },
    attention: {
      backgroundColor: "#fff4e5",
      color: "#e67e22",
      border: "1px solid #f5cba7",
      "&:hover": {
        backgroundColor: "#ffe9cc",
        borderColor: "#e67e22",
      },
    },
    activate: {
      backgroundColor: "#e0f7e9",
      color: "#1b5e20",
      border: "1px solid #a5d6a7",
      "&:hover": {
        backgroundColor: "#c8e6c9",
        borderColor: "#1b5e20",
      },
    },
    deactivate: {
      backgroundColor: "#fff4e5",
      color: "#e65100",
      border: "1px solid #ffcc80",
      "&:hover": {
        backgroundColor: "#ffe0b2",
        borderColor: "#e65100",
      },
    },
    assign: {
      backgroundColor: "#e3f2fd", 
      color: "#0d47a1", 
      border: "1px solid #90caf9",
      "&:hover": {
        backgroundColor: "#bbdefb",
        borderColor: "#0d47a1",
      },
    },
  };

  return (
    <Button
      onClick={onClick}
      variant="contained"
      disableElevation
      sx={{
        textTransform: "none",
        fontSize: "0.7rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "2px 6px", // Tight padding
        minWidth: "unset", // Prevents default button min-width
        lineHeight: 1,
        borderRadius: "6px",
        boxShadow: "none",
        whiteSpace: "nowrap",
        "& .MuiButton-startIcon": {
          margin: 0,
        },
        ...colorStyles[color],
      }}
      startIcon={children}
    >
      {label}
    </Button>
  );
}
